module.exports = __webpack_public_path__ + "static/18-a98446c80c5d01bb0749cd77e6845a98.jpg";